import { stripHtml as strip } from 'string-strip-html';

export const cleanText = (str: string): string => {
  if (!str) {
    return str;
  }

  return strip(str).result.trim();
};
